import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';
import { FamilyTableModalModel } from 'src/app/models/tables/management/family-table-modal.model';
import { ConceptFamilyModel } from 'src/app/models/management/concept-family.model';

@Injectable({
  providedIn: 'root'
})
export class ConceptFamilyService {

  private readonly _httpClient = inject(HttpClient);

  createAsync(conceptFamilyContract: ConceptFamilyModel): Observable<ConceptFamilyModel> {
    return this._httpClient.post<ConceptFamilyModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.CreateConceptFamily}`, conceptFamilyContract
    );
  }

  createSomeAsync(conceptInvoicingId: number, familyIds: number[]): Observable<boolean> {
    return this._httpClient.post<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.CreateSomeAsync}/${conceptInvoicingId}`, familyIds);
  }

  deleteAsync(conceptFamilyId: number): Observable<ConceptFamilyModel> {
    return this._httpClient.delete<ConceptFamilyModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.DeleteConceptFamily}/${conceptFamilyId}`
    );
  }

  deleteSomeAsync(conceptFamilyIds: number[]): Observable<boolean> {
    return this._httpClient.put<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.DeleteSomeAsync}`,
      conceptFamilyIds);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.ExportGeneralConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  getAllConceptFamiliesForAccountingModelWithPaginationAsync(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.GetAllConceptFamiliesForAccountingModelWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getArticlesByFamilyIdForSelectAsync(familyId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.GetArticlesByFamilyIdForSelectAsync}/${familyId}`,);
  }

  getColumnsForFamiliesModalAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.GetColumnsForFamiliesModalAsync}`);
  }

  getColumnsForGeneralConsultationForAccountingModelAsync(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.GetColumnsForGeneralConsultationForAccountingModelAsync}`);
  }

  getConceptFamiliesByConceptInvoicingIdAsync(conceptInvoicingId: number): Observable<ConceptFamilyModel[]> {
    return this._httpClient.get<ConceptFamilyModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.GetConceptFamiliesByConceptInvoicingIdAsync}/${conceptInvoicingId}`);
  }

  getConceptFamiliesByConceptInvoicingIdForSelectAsync(conceptInvoicingId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.GetConceptFamiliesByConceptInvoicingIdForSelectAsync}/${conceptInvoicingId}`);
  }

  getConceptFamilyById(conceptFamilyId: number): Observable<ConceptFamilyModel> {
    return this._httpClient.get<ConceptFamilyModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.GetConceptFamily}/${conceptFamilyId}`
    );
  }

  getFamiliesForConceptInvoicingAsync(conceptInvoicingId: number, page: number, limit: number,
    columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<FamilyTableModalModel>> {
    const params = new HttpParams()
      .set('conceptInvoicingId', conceptInvoicingId)
      .set('page', page)
      .set('limit', limit)
      .set('columnSort', columnSort || '')
      .set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<FamilyTableModalModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.GetFamiliesForConceptInvoicingAsync}`,
      filters, { params: params }
    );
  }

  updateAsync(conceptFamilyContract: ConceptFamilyModel): Observable<ConceptFamilyModel> {
    return this._httpClient.put<ConceptFamilyModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.conceptFamily.UpdateAsync}`, conceptFamilyContract
    );
  }

}
